import { render, staticRenderFns } from "./AnswerPage.vue?vue&type=template&id=36b38412&scoped=true&"
import script from "./AnswerPage.vue?vue&type=script&lang=js&"
export * from "./AnswerPage.vue?vue&type=script&lang=js&"
import style0 from "./AnswerPage.vue?vue&type=style&index=0&id=36b38412&prod&lang=scss&"
import style1 from "./AnswerPage.vue?vue&type=style&index=1&id=36b38412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b38412",
  null
  
)

export default component.exports